import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { watch } from 'vue';
import useProductDetailData from '@/shared/product/details/useProductDetailData';
import useNetPrices from '@/b2b/product/useNetPrices';
import ProductNetPrice from '@/b2b/product/ui/ProductNetPrice.vue';
import { useModuleConfigurator } from '@/shared/product/details/ui/module-configurator/useModuleConfigurator';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetailNetPrice',
  setup(__props) {

const { variantId } = useProductDetailData();
const { fetchNetPrices } = useNetPrices();

const { moduleConfiguratorTileData } = useModuleConfigurator();

const getNetPriceForProduct = () => {
    fetchNetPrices([variantId.value], true);
};

watch([variantId, moduleConfiguratorTileData], getNetPriceForProduct, { immediate: true });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ProductNetPrice, {
    "is-main-pdp-price": true,
    "variant-id": _unref(variantId)
  }, null, 8, ["variant-id"]))
}
}

})